import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {UtilService} from './shared/services/util.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  title = 'medpal-admin-panel';

  progressSpinnerConfig: { show: boolean } = {
    show: false
  };

  constructor(
    private utilService: UtilService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit() {
    this.utilService.loaderService.subscribe((progressConfig) => {
      this.progressSpinnerConfig = progressConfig;
      this.changeDetectorRef.detectChanges();
    });
  }
}
